import React, { useState } from 'react';

// Accessible accordion — one item open at a time.
export default function FaqList({ items, idPrefix = 'faq', defaultOpen = 0 }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="faq">
      {items.map((it, i) => {
        const isOpen = open === i;
        const btnId = `${idPrefix}-q-${i}`;
        const panelId = `${idPrefix}-a-${i}`;
        return (
          <div key={it.q} className={`faq__item ${isOpen ? 'is-open' : ''}`}>
            <h3 className="faq__q">
              <button
                id={btnId}
                type="button"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpen(isOpen ? -1 : i)}
              >
                <span>{it.q}</span>
                <i className="fa-solid fa-chevron-down" aria-hidden="true" />
              </button>
            </h3>
            <div id={panelId} role="region" aria-labelledby={btnId} className="faq__a" hidden={!isOpen}>
              <p>{it.a}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
